import React, { FC, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { Button, Col, Row } from 'antd';

import StaticText from 'shared/layouts/LandingLayout/content.json';

import { SubTitle, Title } from '../ui/Title';
import { Container } from '../ui/Container';
import { Size, useWindowSize } from '../../../../hooks/useWindowSize';
import { ScreenProps } from '../types/landing.interface';

export const TelegramAdvantages: FC<ScreenProps> = () => {
    return (
        <Container maxWidth={1048} marginTop={130} mobileMarginTop={336}>
            <StyledCard>
                <StyledTitle>
                    <SubTitle
                        id={'telegram-advantages'}
                        type='primary'
                        text={StaticText.telegramAdvantages.title}
                    />
                </StyledTitle>
                <StyledOptions>
                    {StaticText.telegramAdvantages.options.map(
                        (option, index) => (
                            <StyledOption key={`${option.title}${index}`}>
                                <StyledOptionTitle>
                                    {option.title}
                                </StyledOptionTitle>
                                <StyledOptionDescription>
                                    {option.description}
                                </StyledOptionDescription>
                            </StyledOption>
                        )
                    )}
                </StyledOptions>
            </StyledCard>
        </Container>
    );
};

const StyledCard = styled.div`
    background: #f3f4f6;
    border-radius: 30px;
    padding: 24px;

    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (max-width: 920px) {
        padding: 10px;
        gap: 10px;
    }
`;

const StyledTitle = styled.div`
    display: block;
    width: 100%;
`;

const StyledOptions = styled.div`
    background: #ffffff;
    padding: 32px 30px;
    display: flex;
    gap: 60px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
    z-index: 2;
    @media (max-width: 920px) {
        flex-wrap: wrap;
        gap: 16px 0;
        padding: 32px 0;
        justify-content: space-between;
    }
`;

const StyledOption = styled.div`
    display: block;
    @media (max-width: 920px) {
        flex: 0 0 50%;
        padding: 0 10px;
    }
`;

const StyledOptionTitle = styled.h4`
    color: #2357ff;

    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 45px;
    margin: 0;

    @media (max-width: 920px) {
        font-size: 24px;
        line-height: 32px;
    }
`;

const StyledOptionDescription = styled.p`
    color: #1f2937;

    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%;
    margin: 10px 0;

    @media (max-width: 920px) {
        font-size: 12px;
        line-height: 17px;
        margin: 8px 0 0;
    }
`;
